export default "__VITE_ASSET__BJZJw$Uc__"